import { create } from 'zustand'

interface ModalPropiedadesComState {
  modalPropiedadesCom: {
    isOpen: boolean
    onSuccess?: () => void
  }
  setModalPropiedadesCom: (modalPropiedadesCom: {
    isOpen: boolean
    onSuccess?: () => void
  }) => void
  reset: () => void
}

const initialState = {
  modalPropiedadesCom: {
    isOpen: false
  }
}

export const useModalPropiedadesComStore = create<ModalPropiedadesComState>()(
  (set) => ({
    ...initialState,
    setModalPropiedadesCom: (modalPropiedadesCom) =>
      set({ modalPropiedadesCom }),
    reset: () =>
      set({
        modalPropiedadesCom: initialState.modalPropiedadesCom
      })
  })
)
